import type { ReactNode } from "react";

export const SUPERINTELLIGENCE_TERM = "superinteligência — SI";

/**
 * Renderiza o texto destacando em itálico o novo termo "superinteligência — SI",
 * mantendo "inteligência artificial", "IA" e "agente de IA" intactos.
 */
export function renderWithSuperintelligenceItalic(text: string): ReactNode {
  const parts = text.split(SUPERINTELLIGENCE_TERM);
  if (parts.length === 1) return text;
  return (
    <span>
      {parts.flatMap((part, index) =>
        index === parts.length - 1
          ? [part]
          : [part, <em key={`si-${index}`}>{SUPERINTELLIGENCE_TERM}</em>],
      )}
    </span>
  );
}
